import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PreloaderComponent } from './components/layout/preloader/preloader.component';
import { HeaderComponent } from './components/layout/header/header.component';
import { FooterComponent } from './components/layout/footer/footer.component';
import { HomeComponent } from './components/pages/home/home.component';
import { FunfactComponent } from './components/common/funfact/funfact.component';
import { FeedbackComponent } from './components/common/feedback/feedback.component';
import { SubscribeComponent } from './components/common/subscribe/subscribe.component';
import { AboutComponent } from './components/pages/about/about.component';
import { FeaturesComponent } from './components/pages/features/features.component';
import { TeamComponent } from './components/pages/team/team.component';
import { BlogComponent } from './components/pages/blog/blog/blog.component';
import { BlogDetailsComponent } from './components/pages/blog/blog-details/blog-details.component';
import { ServicesComponent } from './components/pages/services/services/services.component';
import { ServiceDetailsComponent } from './components/pages/services/service-details/service-details.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { FaqComponent } from './components/pages/faq/faq.component';
import { ComingSoonComponent } from './components/pages/coming-soon/coming-soon.component';
import { NotFoundComponent } from './components/pages/not-found/not-found.component';
import { PricingComponent } from './components/pages/pricing/pricing.component';
import { LoginComponent } from './components/pages/login/login.component';
import { RegisterComponent } from './components/pages/register/register.component';
import { SolutionsComponent } from './components/pages/solutions/solutions/solutions.component';
import { IndustrialComponent } from './components/pages/solutions/industrial/industrial.component';
import { JoinUsComponent } from './components/pages/join-us/join-us.component';
import { SolutionDetailsComponent } from './components/pages/solutions/solution-details/solution-details.component';

import { NCourComponent } from './components/pages/nCour/nCour.component';


import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DatePipe } from '@angular/common';
import { DownloadsComponent } from './components/pages/downloads/downloads.component';
import { EnvironmentalComponent } from './components/pages/environmental/environmental.component';
import { SocialComponent } from './components/pages/social/social.component';
import { GovernanceComponent } from './components/pages/governance/governance.component';
import { FilesComponent } from './components/pages/files/files.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';

@NgModule({
  declarations: [
    AppComponent,
    PreloaderComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    FunfactComponent,
    FeedbackComponent,
    SubscribeComponent,
    AboutComponent,
    FeaturesComponent,
    TeamComponent,
    BlogComponent,
    BlogDetailsComponent,
    ServicesComponent,
    ServiceDetailsComponent,
    ContactComponent,
    FaqComponent,
    ComingSoonComponent,
    NotFoundComponent,
    PricingComponent,
    LoginComponent,
    RegisterComponent,
    SolutionsComponent,
    IndustrialComponent,
    JoinUsComponent,
    SolutionDetailsComponent,
    NCourComponent,
    DownloadsComponent,
    EnvironmentalComponent,
    SocialComponent,
    GovernanceComponent,
    FilesComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatProgressSpinnerModule,
    PdfViewerModule,
  ],
  exports: [
    MatProgressSpinnerModule
  ],
  providers: [DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
